import React, { useState } from 'react';
import { Popover } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { base64Kit } from '@/utils/base64-kit';
import { BaseLayerViewType, PluginEnum, type IImageLayerProps } from '@/version-types';
import { imageLayerAiMenuConfig } from './config';
import './style.less';

enum Menu {
    'AIExpendImage',
    'AIModifyImage',
    'AIGenerateImage',
    'AITextMaterial',
}

const MenuList = (showAIGenerateImage = false) => {
    const { $t } = getLocaleStore();
    const ls = [
        {
            label: $t((v) => v.baseLayer.imageLayerAiItem.aIExpendImage),
            value: Menu.AIExpendImage,
        },
        {
            label: $t((v) => v.baseLayer.imageLayerAiItem.aIModifyImage),
            value: Menu.AIModifyImage,
        },
        {
            label: $t((v) => v.baseLayer.imageLayerAiItem.aiTextMaterial),
            value: Menu.AITextMaterial,
        },
    ];
    if (showAIGenerateImage) {
        ls.unshift({
            label: 'AI生图',
            value: Menu.AIGenerateImage,
        });
    }
    return ls;
};

const ImageLayerAiPopover: React.FC<{
    hasAiText?: boolean;
}> = ({ hasAiText = false }) => {
    const framework = useFramework();
    const hasAIGenerateImage = !window.isIntl && !imageLayerAiMenuConfig.hiddenAIGenerateImage;
    const [renderKey, setRenderKey] = useState(0);

    const menuItemClick = (value: Menu) => {
        if (value === Menu.AIExpendImage) {
            framework.service.registration
                .getInstance<ShortcutMenu>('ShortcutMenu')
                .emitClick(PluginEnum.AI_EXPEND_IMAGE)
                .openPlugin({ func: PluginEnum.AI_EXPEND_IMAGE });
        } else if (value === Menu.AIModifyImage) {
            framework.service.registration
                .getInstance<ShortcutMenu>('ShortcutMenu')
                .emitClick(PluginEnum.AI_MODIFY_IMAGE)
                .openPlugin({ func: PluginEnum.AI_MODIFY_IMAGE });
        } else if (value === Menu.AIGenerateImage) {
            const activeLayer = framework.service.frame.getActivePickLayer();
            const url = base64Kit.getLocalUrl((activeLayer?.data as IImageLayerProps | undefined)?.url ?? '');
            framework.service.registration
                .getInstance<ShortcutMenu>('ShortcutMenu')
                .emitClick(PluginEnum.AI_GENERATE_IMAGE)
                .openPlugin({
                    func: PluginEnum.AI_GENERATE_IMAGE,
                    extData: {
                        replaceActiveImageLayer: true,
                        url,
                    },
                })
                .emitAiGenerateImageEnter('quick');
        } else if (value === Menu.AITextMaterial) {
            framework.service.registration
                .getInstance<ShortcutMenu>('ShortcutMenu')
                .emitClick(PluginEnum.AI_TEXT)
                .openPlugin({ func: PluginEnum.AI_TEXT });
        }
        setRenderKey(renderKey + 1);
    };

    return (
        <div className="shortcut-list__item c-imageLayerAiItem" data-type={BaseLayerViewType.SHORTCUT}>
            <Popover
                placement="bottomLeft"
                overlayClassName="l-content-menu-popover"
                key={renderKey}
                content={
                    <div className="c-imageLayerAiItem-menu">
                        {MenuList(hasAIGenerateImage)
                            .filter((item) => !(!hasAiText && item.value === Menu.AITextMaterial))
                            .map((item) => (
                                <div
                                    key={item.value}
                                    className="item"
                                    data-type={BaseLayerViewType.SHORTCUT}
                                    onClick={() => menuItemClick(item.value)}
                                >
                                    {item.label}
                                </div>
                            ))}
                    </div>
                }
            >
                <div className="icon">
                    <IconFont name="AiTools" fontSize={16} color="var(--content-list-primary)" />
                </div>
            </Popover>
        </div>
    );
};

export default ImageLayerAiPopover;
